/** Tenant label management /metering/tenant/label-manage (labelManage/index.vue) */
export default {
  labelManagePage: {
    phKeyword: 'Label name',
    btnSearch: 'Search',
    btnReset: 'Reset',
    btnRefresh: 'Refresh',
    sectionTitle: 'Tag management',
    btnAddLabel: 'New label',
    sortDefault: 'Default sort',
    colId: 'ID',
    colName: 'Label name',
    colCreateTime: 'Created',
    colUpdateTime: 'Updated',
    colAction: 'Actions',
    btnEdit: 'Edit',
    btnBatchBind: 'Batch assign',
    btnDelete: 'Delete',
    emptyNoData: 'No data',
    emptyNoPermission: 'No permission to view',
    dialogEdit: 'Edit label',
    dialogAdd: 'New label',
    formLabelName: 'Label name',
    phNameInput: 'Enter label name',
    btnCancel: 'Cancel',
    btnConfirm: 'OK',
    dialogBindTitle: 'Batch assign tenants',
    phTenantSearch: 'Tenant name / ID',
    bindCurrentLabel: 'Label:',
    btnSelectAll: 'Select all',
    btnClear: 'Clear',
    colTenantId: 'Tenant ID',
    colTenantName: 'Tenant',
    btnConfirmBind: 'Assign',
    ruleNameRequired: 'Please enter a label name',
    msgQueryFail: 'Query failed',
    msgNoAddPerm: 'No permission to add',
    msgNoEditPerm: 'No permission to edit',
    msgNoDeletePerm: 'No permission to delete',
    msgSaveOk: 'Saved',
    msgSaveFail: 'Save failed',
    titleTip: 'Notice',
    confirmDelete: 'Delete label “{name}”?',
    msgDeleteOk: 'Deleted',
    msgDeleteFail: 'Delete failed',
    msgBindSelectTenant: 'Select at least one tenant',
    msgBindOk: 'Assigned',
    msgBindFail: 'Assign failed',
    msgTenantQueryFail: 'Failed to load tenants'
  }
}
